import { useClient } from '@based/sdk/react'
import { Initiative } from '@schema/initiative'
import { useCallback } from 'react'
import { useAutoSave } from '@app/util/hooks/useAutoSave'

export const useInitiativeAutoSave = (
  initiativeId: number,
  initiative: Partial<Initiative>,
  debounceDelayInSeconds?: number,
) => {
  const client = useClient()
  const save = useCallback(
    (value: Partial<Initiative>) =>
      client.call('edit-initiative', { id: initiativeId, value }),
    [client, initiativeId],
  )

  useAutoSave(initiative, save, debounceDelayInSeconds)
}
